export default "__VITE_ASSET__c50350af__"